import { Spinner } from "@jobber/components/Spinner";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { xeroAccountName, xeroAuthorize } from "services";

const XeroCallback = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const state = searchParams.get("state");
  const error = searchParams.get("error");
  const navigate = useNavigate();

  useEffect(() => {
    if (!code || error) {
      navigate("/error", { replace: true });
    }

    // jobber -> xero flow
    if (state) {
      (async () => {
        try {
          await xeroAuthorize(code, state);
          navigate("/jobber-xero-step2", { replace: true });
        } catch(e: any) {
          navigate("/error", { replace: true });
        }
      })();

    // xero -> jobber flow
    } else {
      (async () => {
        try {
          const { data: res } = await xeroAuthorize(code, null);
          sessionStorage.setItem('state', res.state);
          const { data: accountName } = await xeroAccountName(res.state);
          localStorage.setItem("account", accountName);
          navigate("/xero-jobber-step1", { replace: true });
        } catch(e: any) {
          navigate("/error", { replace: true });
        }
      })();
    }
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Spinner />
      <h1>Xero authentication in progress</h1>
    </div>
  );
};

export default XeroCallback;
